export default __webpack_public_path__ + "static/media/Weather.edac6e99.PNG";